import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Backdrop, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import styles from '../../assets/jss/components/loaderStyle';

const useStyles = makeStyles(styles);

const Loader = (props) => {
    const { isLoading } = props;
    const classes = useStyles();
    const [isOpen, setOpen] = useState(false);

    useEffect(() => {
        let timer = null;
        if (isLoading) timer = setTimeout(() => setOpen(true), 750);
        else setOpen(false);

        return () => clearTimeout(timer);
    }, [isLoading]);

    return (
        <Backdrop className={classes.backdrop} open={isOpen}>
            <CircularProgress color="primary" />
        </Backdrop>
    );
};

Loader.defaultProps = {
    isLoading: false,
};

Loader.propTypes = {
    isLoading: PropTypes.bool,
};

export default Loader;
